/** La pagina Impostazioni: utenti, registry, token di lettura, email, cartelle, backup, lingua. */
export const impostazioni = {
  "impostazioni.intro": "Chi accede a Portman, dove prende le immagini, come ti avvisa e come lo salvi.",
  "impostazioni.sezioni": "Sezione",
  "impostazioni.comeFunziona": "Come funziona",
  "impostazioni.nessunaSezione": "Non hai il permesso per nessuna sezione delle impostazioni.",

  "accessi.titolo": "Accessi non autorizzati",
  "accessi.intro":
    "Gli accessi falliti, raggruppati per indirizzo. Un indirizzo bloccato riceve un rifiuto a ogni richiesta, " +
    "login e webhook compresi. Si blocca l'indirizzo e non lo username, che sceglie chi attacca.",
  "accessi.tentativi": "Tentativi falliti",
  "accessi.nessunTentativo": "Nessun accesso fallito registrato.",
  "accessi.colIp": "Indirizzo IP",
  "accessi.colFalliti": "Falliti",
  "accessi.colUtenti": "Utenti provati",
  "accessi.colUltimo": "Ultimo tentativo",
  "accessi.riusciti": (p: { n: number }) => `${p.n} riusciti`,
  "accessi.riuscitiAiuto": "Da questo indirizzo qualcuno è anche entrato: forse è un utente che ha sbagliato password.",
  "accessi.bloccato": "bloccato",
  "accessi.tuoIp": "il tuo indirizzo",
  "accessi.blocca": "Blocca",
  "accessi.sblocca": "Sblocca",
  "accessi.bloccati": "Indirizzi bloccati",
  "accessi.nessunBloccato": "Nessun indirizzo bloccato.",
  "accessi.ipSegnaposto": "203.0.113.7",
  "accessi.motivo": "Motivo (facoltativo)",
  "accessi.bloccatoDa": (p: { utente: string; quando: string }) => `bloccato da ${p.utente} il ${p.quando}`,

  "generale.titolo": "Generale",
  "generale.intro": "La lingua dell'istanza vale per le email e i log del server.",
  "generale.lingua": "Lingua dell'istanza",
  "generale.daAmbiente": "La imposta PORTMAN_LANG: per cambiarla modifica la variabile e riavvia Portman.",

  "registry.titolo": "Registry privati",
  "registry.intro":
    "Le credenziali restano cifrate nel database. Portman le consegna a Docker solo per la durata di un pull, " +
    "in un file temporaneo che cancella subito dopo.",
  "registry.aggiungi": "Aggiungi registry",
  "registry.vuoto":
    "Nessun registry configurato: Portman scarica le immagini pubbliche e, per quelle private, " +
    "si affida alla configurazione Docker della macchina.",
  "registry.indirizzo": "Indirizzo",
  "registry.indirizzoAiuto": "L'host come compare nel nome dell'immagine. Per Docker Hub: docker.io.",
  "registry.utente": "Utente",
  "registry.password": "Password o token",
  "registry.passwordAiuto": "Non sarà più visibile dopo il salvataggio.",
  "registry.salva": "Salva credenziali",

  "token.durata1h": "1 ora",
  "token.durata1g": "1 giorno",
  "token.durata7g": "7 giorni",
  "token.durata30g": "30 giorni",
  "token.revocato": "revocato",
  "token.scaduto": "scaduto",
  "token.creatoreNonValido": "creatore non valido",
  "token.senzaStack": "senza stack",
  "token.titolo": "Token di lettura",
  "token.intro":
    "Danno accesso in sola lettura a elenco, stato e log degli stack scelti, per strumenti esterni. " +
    "Si passano nell'header Authorization, mai nell'URL, e decadono con il loro creatore.",
  "token.crea": "Crea token",
  "token.vuoto": "Nessun token di lettura.",
  "token.revocaConferma": (p: { nome: string }) =>
    `Revocare il token "${p.nome}"? Gli strumenti che lo usano smetteranno di funzionare.`,
  "token.nessunoStack": "nessuno stack",
  "token.scade": (p: { quando: string }) => `scade il ${p.quando}`,
  "token.ultimoUso": (p: { quando: string; ip: string | null }) =>
    `ultimo uso ${p.quando}${p.ip ? ` da ${p.ip}` : ""}`,
  "token.creatoDa": (p: { chi: string }) => `creato da ${p.chi}`,
  "token.creatoreRimosso": "creatore rimosso",
  "token.nomeAiuto": "Per riconoscerlo nell'elenco, ad esempio lo strumento che lo usa.",
  "token.durata": "Durata",
  "token.durataAiuto": "Allo scadere smette di funzionare: non si rinnova.",
  "token.stackLeggibili": "Stack leggibili",
  "token.nessunoStackDisponibile": "Nessuno stack disponibile.",
  "token.copialoOra": "Non sarà più visibile: copialo ora.",
  "token.copia": "Copia token",
  "token.copiaFallita": "Copia non disponibile: seleziona il token e copialo a mano.",

  "guida.passo1": "Crealo con i soli stack che servono e la durata più breve che basta.",
  "guida.passo2":
    "Copialo e salvalo in un file leggibile solo da te, fuori da qualunque repository. Su macOS, subito dopo «Copia token»:",
  "guida.passo2Altrove":
    "Altrove incollalo con un editor nel file, poi chmod 600. Non scriverlo in un comando come echo: " +
    "resterebbe nella cronologia della shell.",
  "guida.passo3": "Verifica quali stack può leggere:",
  "guida.passo3Log": "e segui i log di uno stack in tempo reale:",
  "guida.passo4":
    "Con un assistente come Claude Code, indica il percorso del file e l'id dello stack. " +
    "Non incollare il token in chat: resterebbe nella trascrizione anche dopo la revoca.",
  "guida.passo5": "Quando hai finito, revocalo qui sotto.",

  "email.titoloSezione": "Email e avvisi",
  "email.intro":
    "Server SMTP, destinatari e soglie globali: ogni stack può sovrascrivere le soglie dalla propria scheda Risorse. " +
    "La password è cifrata e non viene mai mostrata.",
  "email.server": "Server SMTP",
  "email.porta": "Porta",
  "email.sicurezza": "Sicurezza",
  "email.sicurezzaNessuna": "Nessuna",
  "email.passwordImpostata": "impostata — lascia vuoto per non cambiarla",
  "email.mittente": "Mittente",
  "email.mittenteAiuto": "L'indirizzo da cui partono le email.",
  "email.indirizzoPubblico": "Indirizzo pubblico di Portman",
  "email.indirizzoPubblicoAiuto": "Base dei link nelle email.",
  "email.destinatari": "Destinatari",
  "email.destinatariAiuto": "Un indirizzo per riga.",
  "email.cpuOltre": "CPU oltre (%)",
  "email.perMinuti": "per (minuti)",
  "email.memoriaOltre": "Memoria oltre (%)",
  "email.provaInviata": "Email di prova inviata.",
  "email.inviaProva": "Invia email di prova",
  "email.salvaPrima": "Salva per poter inviare la prova: usa ciò che è salvato.",
  "email.connessione": "Connessione al server SMTP, fino a 15 secondi…",

  "cartelle.titolo": "Cartelle",
  "cartelle.intro": "Le cartelle dell'host che gli stack montano come bind mount.",
  "cartelle.comeFunziona":
    "Sorgenti dei bind mount degli stack, create da Portman (uid 1000) invece che dal daemon Docker: " +
    "su una share con root_squash il root del daemon non può farne il chown.",
  "cartelle.nonAttiva":
    "Non attiva. Imposta PORTMAN_STORAGE_ROOT (es. /srv/shared-storage) e monta quella cartella " +
    "nel container di Portman allo stesso percorso.",
  "cartelle.filtro": "Filtra per nome…",
  "cartelle.contoFiltrato": (p: { n: number; totale: number }) => `${p.n} di ${p.totale} cartelle`,
  "cartelle.conto": (p: { n: number }) => `${p.n} cartelle`,
  "cartelle.nessuna": "Nessuna sottocartella.",
  "cartelle.nessunaFiltro": "Nessuna cartella corrisponde al filtro.",
  "cartelle.nuovaSegnaposto": "nuova-cartella  (anche test01/test01_uploads)",
  "cartelle.crea": "Crea cartella",
  "cartelle.eliminaConferma": (p: { nome: string }) => `Eliminare la cartella "${p.nome}"? Deve essere vuota.`,
  "cartelle.elimino": "Elimino…",

  "database.titolo": "Backup",
  "database.intro": "Una copia del database con tutto ciò che Portman sa: la scarichi, o la ripristini.",
  "database.comeFunziona":
    "Una copia contiene tutto: stack, revisioni, utenti e segreti — questi ultimi cifrati con la master key attuale. " +
    "Conserva la master key insieme al backup: senza, gli stack ripristinati non sanno più le proprie password. " +
    "Restano fuori solo lo storico delle metriche e degli avvisi, che riparte da zero dopo un ripristino.",
  "database.scarica": "Scarica una copia",
  "database.scaricaAiuto": "Presa senza fermare Portman, coerente anche con un rilascio in corso.",
  "database.scaricaBackup": "Scarica backup",
  "database.ripristina": "Ripristina una copia",
  "database.ripristinaAiuto":
    "Il database attuale viene messo da parte come portman-prima-del-ripristino.db nella cartella dei dati, " +
    "poi Portman si riavvia. Se non è supervisionato — in un container con restart policy, o sotto systemd — va riavviato a mano.",
  "database.ripristinaConferma": (p: { file: string }) =>
    `Ripristinare "${p.file}"? Il contenuto attuale di Portman — stack, utenti e storico — viene sostituito da quello del backup.`,
};
